module.exports = __webpack_public_path__ + "img/4.3f99e7f7.jpg";